import { useEffect, useState } from "react";
import Reports from "../components/reports";
import { SIGNAL_ASPECT_BLANKING_REPORT_DATA } from "../constants/data.cnst";
import { TABLE_COLUMNS_CONFIG, type ColumnMeta } from "../constants/table.cnst";
import type { SIGNAL_ASPECT_BLANKING_REPORT } from "../interfaces/dashboard";

export default function SignalAspectBlanking() {
    const signalAspectBlankingReportTableColumns: ColumnMeta[] = TABLE_COLUMNS_CONFIG.SIGNAL_ASPECT_BLANKING_REPORT;

    const [signalAspectBlankingReportTableData, setSignalAspectBlankingReportTableData] = useState<SIGNAL_ASPECT_BLANKING_REPORT[]>([]);

    useEffect(() => {
        setSignalAspectBlankingReportTableData(SIGNAL_ASPECT_BLANKING_REPORT_DATA)
    }, []);

    return (
        <Reports
        reportType="SIGNAL_ASPECT_BLANKING"
        tableColumns={signalAspectBlankingReportTableColumns}
        tableData={signalAspectBlankingReportTableData} />
    );
}